import React from "react";

interface CheckoutActionButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
  className?: string;
  fullWidth?: boolean;
}

const CheckoutActionButton: React.FC<CheckoutActionButtonProps> = ({
  children,
  disabled = false,
  onClick,
  type = "button",
  className = "",
  fullWidth = false,
}) => (
  <button
    type={type}
    className={`btn btn-primary split-discount-apply-button${fullWidth ? " w-100" : ""}${className ? ` ${className}` : ""}`}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);

export default CheckoutActionButton;
